import { BASE } from "constants/routes";
import { modalTypes } from "constants/types";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getSessionInfo } from "slices/app/actions/app";
import { hideModal, showModal } from "slices/app/actions/modals";

export const WORKSPACE_SYNC_CHANNEL = "workspace-sync";
export const TAB_ID = globalThis.crypto?.randomUUID?.();

export const useWorkspaceSync = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const channel = new BroadcastChannel(WORKSPACE_SYNC_CHANNEL);
    channel.onmessage = (event) => {
      if (
        event.data?.type === "workspace-changed" &&
        event.data?.tabId !== TAB_ID
      ) {
        dispatch(getSessionInfo(navigate, { skipPendingRedirect: true }));
        navigate(BASE);

        dispatch(
          showModal(modalTypes.CONFIRMATION, {
            headerText: "Workspace Changed",
            bodyText:
              "Your workspace was changed in another tab. Your workspace has been updated and you have been redirected to the homepage.",
            okButton: {
              text: "Got It",
              onOk: () => dispatch(hideModal(modalTypes.CONFIRMATION)),
            },
          })
        );
      }
    };
    return () => channel.close();
  }, []);
};
